'use strict';

class PlanClient {
    constructor() {
        this.base = window.SYSTEM_ENVIRONMENT_VARIABLES.ROBOX_CLIENT_URI;
        this.endpoint = 'public/plans/'
    }

    read(id) {
        return fetch(
            `${this.base}${this.endpoint}${id}`,
            {
                method: 'GET',
            }
        );
    }
}

export default PlanClient;



// WEBPACK FOOTER //
// ./scripts/clients/robox-api/PlanClient.js